import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import './BackofficePage.css';

const BackofficePage = () => {
  return (
    <>
      <Header />
      
      <div className="backoffice-container">
        <div className="backoffice-content">
          <div className="backoffice-left">
            <div className="backoffice-logo">
              <img src="/logo/Logo_Sem_Fundo.png" alt="Veridicus Logo" />
              <h1 className="overlay-title">BACKOFFICE</h1>
            </div>
          </div>
          
          <div className="backoffice-right">
            <div className="backoffice-description">
              <p className="backoffice-intro">
                Centralize a gestão administrativa e jurídica em um único ambiente confiável.
              </p>
              
              <ul className="backoffice-services">
                <li>Registros e cadastros em órgãos públicos</li>
                <li>Emissão de certidões e documentos oficiais</li>
                <li>Protocolos e acompanhamento de processos administrativos</li>
                <li>Elaboração e controle de petições</li>
                <li>Suporte em conselhos profissionais e agências reguladoras</li>
              </ul>
              
              <p>
                Com a plataforma da Veridicus, toda a operação de backoffice ganha segurança e fluidez. As rotinas são automatizadas,
                os prazos monitorados em tempo real e os documentos ficam organizados em um sistema centralizado. 
                Isso reduz riscos e burocracias, aumenta a eficiência do time e garante total transparência no acompanhamento das demandas, 
                sem necessidade de estrutura interna pesada.
              </p>
            </div>
            
            <div className="backoffice-cta">
              <Link to="/fale-conosco" className="cta-button">
                Entre em contato
              </Link>
            </div>
          </div>
        </div>
        
        <div className="backoffice-navigation">
          <div></div>
          <Link to="/servicos/terceirizacao" className="nav-next">
            TERCEIRIZAÇÃO DE PROCESSOS →
          </Link>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default BackofficePage;